import React from "react"

type SST<TState> = React.Dispatch<React.SetStateAction<TState>>
type AT<TState> = (data: Partial<TState>) => void;

export function createSetStateAction<TState>(setState_: SST<TState>): AT<Partial<TState>> {
  return (data: Partial<TState>): void => {
    setState_((state) => ({
      ...state,
      ...data,
    }))
  }
}
